

  <!-- Header -->
  <header class="w3-container" style="padding-top:22px">
      <h5 ><b><i class="fa fa-dashboard"></i> MC Analysis</b></h5>
    </header>
  
    
  
    <div class="w3-panel">
      <div class="w3-row-padding" style="margin:0 -16px">
        
        <div class="w3-half">
            <h5>System Usage</h5>
            
          <div class="w3-half">         
              <mat-card>
            <div id="chartContainer" style="height: 420px; width: 100%;"></div>
          </mat-card>
          </div>
          <div class="w3-half">        
              <mat-card>           
            <div style="max-height: 420px; overflow: scroll;">
              <table  class="w3-table w3-striped w3-white">
                <tr>
            
                  <th>Date</th>
                  <th>No. of Student</th>             
                  <th>No. of Exercise</th>
                </tr>
                
                        
              </table>
            </div>
          </mat-card>
          </div>
        
        </div>
        
        <div  class="w3-half">
          <h5>Last 50 Student Activities</h5>
          <mat-card>
          <div style="max-height: 420px; overflow: scroll;">
          <table  class="w3-table w3-striped w3-white">
            <tr>
              <th></th>            
              <th>Student</th>
              <th>Paper Name</th>
              <th>Score</th>
              <th></th>
              <th></th>
              <th>Date</th>
            </tr>
            
                    
          </table>
        </div>
      </mat-card>
        </div>
        
      </div>
    </div>
    <hr>
    
  
    <div class="w3-container ">
      <h5>MC Details</h5>
      <div class="alert alert-secondary" role="alert">
          A simple secondary alert—check it out!
        </div>
      <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
        <tr>
          <th>Paper</th>
          <th>Topic</th>
          <th>Question No</th>
          <th>Answer</th>
          <th>Performance</th>
          <th>Correct Rate</th>
          <th></th>
   
        </tr>
        <tr *ngFor="let question of mcdetails | async">
            <td> {{question.name}}</td>
          <td> {{question.hashtag | lowercase}}</td>
          <td> {{question.no}}</td>
          <td> {{question.answer}}</td>
          <td> {{question.correct}} / {{question.people}} </td>
          <td> {{question.rate | percent}}</td>
          <td><mat-progress-bar class="w3-theme-d1" style="height: 20px;width: 100px" mode="determinate" value="{{question.rate *100}}"></mat-progress-bar></td>
         
        </tr>
        
       
        
        
        
      </table><br>
      
    </div>
    <hr>
    
  
    <!-- Footer -->
    <footer class="w3-container w3-padding-16 w3-theme-d3">
      <h4>StudyBio.net</h4>
      <p>Themed by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">w3.css</a> | <a href="https://material.angular.io/" target="_blank">Angular Material</a> | <a href="https://getbootstrap.com/" target="_blank">Bootstrap</a></p>
      <p>Frontend using <a href="https://angular.io/" target="_blank">Angular</a></p>
    </footer>
  
    <style type="text/css"> 
      .not-active { 
          pointer-events: none; 
          cursor: default; 
      } 
      </style> 